import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ComposableMap, Geographies, Geography, ZoomableGroup } from "react-simple-maps";

import { useTrackingData, useShipmentData } from '../../components/DataProviders';

//import mapData from './world-110m';
import mapData from './countries-50m.json';
import AnimatedRoute from './AnimatedRoute';


const WORLD_CONFIG = { zoom: 1.05, center: [0,35] }; // lng, lat
const US_CONFIG = { zoom: 6.5, center: [-96,38.5] }; // lng, lat
const CANADA_CONFIG = { zoom: 3.5, center: [-105,60.5] };
const US_CANADA_CONFIG = { zoom: 2.7, center: [-110, 55] };
const GB_CONFIG = { zoom: 14, center: [-4,54.7] };
const AU_CONFIG = { zoom: 5.7, center: [132,-28.5] };
const NZ_CONFIG = { zoom: 13, center: [172,-41.3] };

const useMapConfig = () => {
  const { carrier_events=[] } = useTrackingData();
  const sourceCountry = carrier_events.reduceRight( (country,e) => (country || e.country_code), null ) || 'US';
  const { destination: { country_code: destinationCountry } = {} } = useShipmentData();

  if( (sourceCountry==='US' && destinationCountry==='CA') || (sourceCountry==='CA' && destinationCountry==='US') ) {
    return US_CANADA_CONFIG;
  }

  if( sourceCountry !== destinationCountry ) {
    return WORLD_CONFIG;
  }

  switch(sourceCountry) {
    case 'US':
      return US_CONFIG;
    case 'CA':
      return CANADA_CONFIG;
    case 'GB':
      return GB_CONFIG;
    case 'AU':
      return AU_CONFIG;
    case 'NZ':
      return NZ_CONFIG;
    default:
      return WORLD_CONFIG;
  }
};

const useStyles = makeStyles( theme => ({
  root: {
    border: '1px solid #e6e6e6',
    background: '#f0f0f0',
    '& svg': {
      maxHeight: '100%',
      width: '100%'
    },
    '& .marker': {
      transition: 'all 200ms',
      '&:hover': {
        transform: 'scale(2)'
      }
    }
  }
}));

export default function Map({ highlightEvent, className='' }) {
  const classes = useStyles();
  const { zoom, center } = useMapConfig();

  // console.log(highlightEvent); // Placeholder for drawing the pins on timeline hover

  return <div className={`${classes.root} ${className}`}>
    <ComposableMap projection='geoMercator'>
      <ZoomableGroup center={center} zoom={zoom}>
        <Geographies geography={mapData}>
          {({ geographies }) =>
            geographies.map( geo =>
              <Geography key={geo.rsmKey} geography={geo} fill="#CCC" stroke="#EEE" strokeWidth="0.5px" />
            )
          }
        </Geographies>
        <AnimatedRoute zoom={zoom} />
      </ZoomableGroup>
    </ComposableMap>
  </div>;
}




